import { useEffect, useState } from 'react';
import type { EmployeesByCourseReportFilterI, CourseEmployeesReportTotalsI, EmployeesByCourseReportI } from 'types';
import { reportsApi } from 'Api/axios/reports-api';

const defaultTotals: CourseEmployeesReportTotalsI = {
  enrolledEmployees: 0,
  approvedEmployees: 0,
  pendingEmployees: 0,
  progressPercentage: 0.0,
  trainingHours: '00:00:00',
};

interface Props {
  courseId: string;
  init?: boolean;
}

const useCourseEmployeesReportApi = ({ courseId, init = false }: Props) => {
  const [data, setData] = useState<EmployeesByCourseReportI[]>([]);
  const [totals, setTotals] = useState<CourseEmployeesReportTotalsI>(defaultTotals);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /**
   * Obtiene todos los empleados de un curso específico
   */
  const fetchCourseEmployees = async (courseId: string, filters: EmployeesByCourseReportFilterI = {}) => {
    setLoading(true);
    const response = await reportsApi.readEmployeesByCourse(courseId, filters);
    setData(response.data ?? []);
    setLoading(false);
    setError(response.error);
  };

  /**
   * Obtiene los datos totales de un curso en específico.
   * @param courseId - El ID del curso.
   */
  const fetchCourseEmployeesTotals = async (courseId: string) => {
    setLoading(true);
    const response = await reportsApi.readEmployeesByCourseTotals(courseId);
    setTotals(response.data ?? defaultTotals);
    setLoading(false);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchCourseEmployees(courseId);
      fetchCourseEmployeesTotals(courseId);
    }
  }, [init]);

  return {
    data,
    totals,
    loading,
    error,
    fetchCourseEmployees,
    fetchCourseEmployeesTotals,
  };
};

export default useCourseEmployeesReportApi;
